<template>
<div class="send-request-master">
    <div class="send-request-wrap">
        <div>
            <h3>Унесите Податке: </h3>
            
            <p>
                Број рачуна: 
                <input type="text" v-model="receiptNumber" :maxlength="inputLength">
            </p>
            <p>
                Датум издавања рачуна:
                <span class="date-input" @click="calendarToggle">
                    {{receiptDate}}
                </span>
            </p>
            <p>
                Број извода из банке: 
                <input type="text"  v-model="bankNumber" :maxlength="inputLength">
            </p>
            <p>
                Трошак финансиран од Општине: 
                <input type="text" v-model="officialSpending" :maxlength="inputLength">
            </p>
            <p>
                Сопствени допринос: 
                <input type="text" v-model="personalSpendings" :maxlength="inputLength">
            </p>
            <p>
                Фотографија рачуна: 
                <label for="receiptImg" class="file-input">Изабери</label>
                <input type="file" @change="resizeReceipt" ref="receiptImg" id="receiptImg">
            </p>
            <p v-for="(i,idx) in receiptNewImg" :key="'receiptImg'+idx"
                class="selected-img-tab">
                <span>{{i.name}}</span>
                <span class="clear-img-button"
                    @click="clearReceiptImg(idx)">
                X</span>
            </p>
            <p>
                Фотографија извода из банке: 
                <label for="bankImg" class="file-input">Изабери</label>
                <input type="file" @change="resizeBankImg" ref="bankImg" id="bankImg">
            </p>
            <p v-for="(i,idx) in bankNewImg" :key="'bankImg'+idx"
                class="selected-img-tab">
                <span>{{i.name}}</span>
                <span class="clear-img-button"
                    @click="clearBankImg(idx)">
                X</span>
            </p>
            <p>
                <button @click="sendingRequest">Потврди</button>
                <button @click="close">Одустани</button>
            </p>
        </div>
    </div>

    <calendar
        v-if="calendarOpened"
        @close="updateDate">
    </calendar>

    <success-popup
        v-if="successPopupOpened"
        @close="closeSuccessPopup">
      </success-popup>

    <error-msg v-if="displayError" @close="displayError=false" :msgText="errMsg" :fatal="isFatal"/>
</div>
  
</template>

<script>
import Calendar from '@/components/Calendar.vue'
import SuccessPopup from '@/components/SuccessPopup.vue'
import ErrorMsg from '../components/ErrorMsg'
import extraData from '../extraData.js'
import axios from 'axios'

export default {
    components:{
        Calendar,
        SuccessPopup,
        ErrorMsg
    },

    props:{
        labelIdToChange: Number
    },
    data(){
        return {
            officialSpending: 0,
            personalSpendings: 0,
            receiptNumber:"",
            receiptDate: new Date().getFullYear()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),
            bankNumber:"",
            receiptNewImg: [],
            bankNewImg: [],
            resizeCounter: 0,
            inputLength:200,
            calendarOpened:false,
            successPopupOpened: false,
            errMsg:'',
            displayError:false,
            isFatal:false
        }
    },
    methods:{
        resizeReceipt(){
            if(this.$refs.receiptImg.files[0].size<400000){
                this.receiptNewImg.push(this.$refs.receiptImg.files[0]); 
                return;
            }
            this.resizeImg(this.$refs.receiptImg.files[0],'rec');
        },
        resizeBankImg(){
            if(this.$refs.bankImg.files[0].size<400000){
                this.bankNewImg.push(this.$refs.bankImg.files[0]);
                return;
            }
            this.resizeImg(this.$refs.bankImg.files[0],'bank');
        },
        sendingRequest(){
            if(this.checkInputs()){return;}
            let formData = new FormData();
            formData.append('sid', sessionStorage.getItem("sid"));
            formData.append('racunBroj', this.receiptNumber);
            formData.append('racunDatum', this.receiptDate);
            formData.append('izvodBroj', this.bankNumber);
            formData.append('opstinsko', this.officialSpending);
            formData.append('licno', this.personalSpendings);
            formData.append('stavkaId', this.labelIdToChange);
            for(let i=0; i<this.receiptNewImg.length; i++){
                formData.append('racunSlika', this.receiptNewImg[i]);
            }
            for(let i=0; i<this.bankNewImg.length; i++){
                formData.append('izvodSlika', this.bankNewImg[i]);
            }
            // console.log(this.receiptNewImg);
            // console.log(this.$refs.bankImg.files[0]);
            axios.post(extraData.adress+"request",formData).then((res)=>{
                if (res.data.res==="ok"){
                    this.errMsg=''
                    this.displayError=false
                    this.isFatal=false
                    // console.log(res);
                    this.successPopupOpened=true;
                }
                else{
                    this.errMsg=res.data.msg
                    this.displayError=true
                    if (res.data.msg==="Нисте улоговани") this.isFatal=true
                }
            }).catch(() => {
                    // console.log(e);
                    this.errMsg="Дошло је до проблема при конектовању на сервер";
                    this.isFatal=true;
                    this.displayError=true;
            })
        },
        showInputError(msg){
            this.errMsg=msg;
            this.isFatal=false;
            this.displayError=true;
        },
        checkInputs(){
            if(this.receiptNumber.trim().length===0){this.showInputError('Морате унети број рачуна'); return true;}
            if(this.bankNumber.trim().length===0){this.showInputError('Морате унети број извода из банке'); return true;}
            if(isNaN(parseFloat(this.officialSpending))){
                this.showInputError('Трошак финансиран од општине мора бити унет као број'); 
                return true;
            }
            if(parseFloat(this.officialSpending).toString()!==this.officialSpending){
                this.showInputError('Неправилан унос трошка финансираног од општине, користите само бројеве и тачку'); 
                return true;
            }
            if(isNaN(parseFloat(this.personalSpendings))){
                this.showInputError('Сопствени допринос мора бити унет као број'); 
                return true;
            }
            if(parseFloat(this.personalSpendings).toString()!==this.personalSpendings){
                this.showInputError('Неправилан унос сопственог доприноса, користите само бројеве и тачку'); 
                return true;
            }
            if(this.$refs.receiptImg.files.length===0){this.showInputError('Морате додати слику рачуна'); return true;}
            if(this.$refs.bankImg.files.length===0){this.showInputError('Морате додати слику извода из банке'); return true;}
            return false;
        },
        resizeImg(imgFile, targetInfo){
            // console.log('func start');
            let reader= new FileReader();
            reader.readAsDataURL(imgFile);
            reader.onload= (e)=>{
                // console.log('reader onload start');
                const MAX_WIDTH = 1200;
                const MAX_HEIGHT = 1200;
                let img = document.createElement("img");

                img.src = e.target.result;
                let width = img.width;
                let height = img.height;

                if((width===0 || height===0) && this.resizeCounter<3){
                    this.resizeCounter++;
                    this.resizeImg(imgFile, targetInfo);
                    return;
                }
                this.resizeCounter=0;
 
                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width;
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                }
                
                let canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                let ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob((blob) =>{
                    if(targetInfo==='rec'){
                        this.receiptNewImg.push(new File([blob], imgFile.name.split(".")[0]+'.jpg', { type: 'image/jpeg' }));
                        // console.log(this.receiptNewImg);
                    }
                    if(targetInfo==='bank'){
                        this.bankNewImg.push(new File([blob], imgFile.name.split(".")[0]+'.jpg', { type: 'image/jpeg' }));
                        // console.log(this.bankNewImg);
                    }
                }, 'image/jpeg', 0.40);

            }
        },
        clearReceiptImg(idx){
            this.receiptNewImg.splice(idx,1);
        },
        clearBankImg(idx){
            this.bankNewImg.splice(idx,1);
        },
        calendarToggle(){
            this.calendarOpened=!this.calendarOpened;
        },
        closeSuccessPopup(){
            this.successPopupOpened=!this.successPopupOpened;
            this.close();
        },
        updateDate(newDate){
            this.receiptDate=newDate.getFullYear()+'-'+(newDate.getMonth()+1)+'-'+newDate.getDate();
            this.calendarToggle();
        },
        close(){
            this.$emit("close");
        }
    }
}
</script>

<style lang="scss" scoped>
    .send-request-master{
        color: #000;
    }
    .send-request-wrap{
        @include PopupStyling();
        h3{
            text-align: center;
        }
        >div>p{
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        input[type=text]{
            text-align: right;
            flex-basis: 200px;
            flex-shrink: 0;
            padding: 2px 5px;
            border: 1px solid #bbb;
            border-radius: 5px;
        }
        input[type=date]{
            text-align: center;
            flex-basis: 220px;
            flex-shrink: 0;
        }
        input[type=file]{
            flex-basis: 234px;
            flex-shrink: 0;
            border: 1px solid #888;
            border-radius: 5px;
            cursor: pointer;
            display: none;
        }
        .file-input{
            flex-basis: 200px;
            flex-shrink: 0;
            padding: 2px 5px;
            border: 1px solid #bbb;
            border-radius: 5px;
            cursor: pointer;
            text-align: center
        }
        .date-input{
            flex-basis: 200px;
            flex-shrink: 0;
            padding: 2px 5px;
            border: 1px solid #bbb;
            border-radius: 5px;
            cursor: pointer;
            text-align: center
        }
        .selected-img-tab{
            border: 1px solid royalblue;
            color: royalblue;
            border-radius: 5px;
            padding: 2px 4px;
        }
        .clear-img-button{
            cursor: pointer;
        }
        button{
            @include ButtonStyling();
        }
    }

    @media only screen and (max-width: 768px) {
        .send-request-wrap{
            >div{
                padding: 5px;
            }
        }
    }
</style>